import { render } from "./Ai247.vue?vue&type=template&id=58b8034c"
import script from "./Ai247.vue?vue&type=script&lang=ts"
export * from "./Ai247.vue?vue&type=script&lang=ts"
script.render = render

export default script